import chaLogo from "@/assets/cha-logo.jpg";
import { Link } from "react-router-dom";
const Footer = () => {
  return <footer className="bg-card border-t border-border py-12">
      <div className="container mx-auto px-[20px]">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={chaLogo} alt="The Children's Hour Academy" className="h-12 w-auto" />
              <div>
                <h3 className="font-header font-bold text-lg text-foreground">The Children's Hour Academy</h3>
              </div>
            </div>
            <p className="text-muted-foreground text-sm">
              Nurturing young hearts and fostering excellence in early childhood education since 1987.
            </p>
          </div>
          
          <div>
            <h4 className="font-header font-semibold text-foreground mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#about" className="text-muted-foreground hover:text-primary-deep transition-colors">About Us</a></li>
              <li><a href="#programs" className="text-muted-foreground hover:text-primary-deep transition-colors">Programs</a></li>
              <li><a href="#spark" className="text-muted-foreground hover:text-primary-deep transition-colors">SPARK Rating</a></li>
              <li><Link to="/school-building-photos" className="text-muted-foreground hover:text-primary-deep transition-colors">About the School Building Photos</Link></li>
              <li><a href="#contact" className="text-muted-foreground hover:text-primary-deep transition-colors">Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-header font-semibold text-foreground mb-4">Contact Info</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>17650 SW 65th Avenue</li>
              <li>Lake Oswego, OR 97035</li>
              <li><a href="tel:5036352139" className="hover:text-primary-deep transition-colors">(503) 635-2139</a></li>
              <li>Monday - Friday 7:30 AM - 5:30 PM</li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-border text-center text-sm text-muted-foreground py-[4px]">
          <p>&copy; {new Date().getFullYear()} The Children's Hour Academy. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};
export default Footer;